exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#advanced-search-content h1[data-v-8491fb72]{font-size:20px}", ""]);

// exports
